import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet, useNavigate } from 'react-router-dom';
import { FullscreenLoading } from '@components/Loading';
import { useQueryClient } from '@tanstack/react-query';
import { alertsQueryKeys } from '@services/alert/keys';
import { sanitizeRedirectUrl } from '@utils/url';

export const RequiredAuth = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { oktaAuth, authState } = useOktaAuth();
  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      oktaAuth.setOriginalUri(originalUri);

      const validRedirect = sanitizeRedirectUrl(originalUri);
      if (validRedirect) {
        localStorage.setItem('redirectUrl', validRedirect);
        const expiration = new Date();
        expiration.setHours(expiration.getHours() + 1);
        localStorage.setItem('redirectUrlExpiration', expiration.toISOString());
      }
      // redirect to /sign-up for flows that require registration
      const isPresetQuote = originalUri.includes('new-quote?preset');
      const isApiPartnerIndication = originalUri.includes('/indication/') && originalUri.includes('source=api-partner');
      if (isPresetQuote || isApiPartnerIndication) {
        navigate('/sign-up');
        return;
      }
      navigate('/login');
    } else {
      // When user becomes authenticated (login or session resume), invalidate alert queries
      // to ensure they're fetched with the new auth token
      queryClient.invalidateQueries({ queryKey: alertsQueryKeys.all });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oktaAuth, !!authState, authState?.isAuthenticated, authState, navigate, queryClient]);

  if (!authState || !authState?.isAuthenticated) {
    return <FullscreenLoading />;
  }

  return <Outlet />;
};
